import React, { useEffect, useState, useContext } from "react";
import TicketSummary from "../ReviewTickets/TicketSummary";
import _ from "lodash";
import CouponBox from "./CouponBox";
import CartButtons from "./CartButtons";
import { baseUrl } from "../../../../../config/config";

import { captureApi, createWaitlist } from "../../../../../crud/checkout.crud";
// import PayByRazorPay from "./RazorPayButton";
import GetCurrency from "../../../../../helpers/services";
import WidgetContext from "../../../../../contexts/WidgetContext";
import Router from "next/router";
import {
	addTeamDetailsToCapture,
	errorToaster,
	paymentErrorHelper,
	removeTeamDetailsFromSessionStorage
} from "../../../../../helpers/utils";
import Ticket from "./Settlements/calculations";
import ViewSummary from "../../../../../components/Modal/ViewSummary";
import moment from "moment";
import { formatCurrencyAmount, getGroupDiscountDetails, isOnDiscount } from "../../../../../helpers/common";
import OfferBox from "./OfferBox";

const CartBox = ({
	reviewDetails,
	selectedTickets,
	attendeesDetails,
	eventDetails,
	query,
	ticketDetails,
	groupDiscounts,
	getCouponDetails,
	removeCoupon,
	couponErr,
	setCouponErr,
	curComp,
	onProceed,
	isWidget,
	setIsCheckoutSubmitted,
	isSingleTicketWidget,
	emailApiErrors,
	isMobile,
	utm,
	waitlistDetails,
	textInputErrors,
	GSTDetails,
	isValidating,
	setFormRules,
	isEventPageTeamComp
}) => {
	const [apiLoading, setApiLoading] = useState(false);
	const {
		isApproval,
		isInternationalEvent,
		paymentMethod,
		isInternationalTicket,
		...widgetContext
	} = useContext(WidgetContext);
	const [isWaitlist, setIsWaitlist] = useState(false);

	const [showTicketSummary, setShowTicketSummary] = useState(false);
	const eventId = eventDetails.event_id;

	const groupDiscountDetails = getGroupDiscountDetails(
		groupDiscounts,
		selectedTickets,
		widgetContext.couponCode
	);
	//Tax and pg charges percentage and details
	const paymentMethodFee = isInternationalEvent
		? 0
		: paymentMethod
			? eventDetails[`${paymentMethod}_pg_percentage`]
			: eventDetails.cards_pg_percentage;
	const taxPercentage = eventDetails.tax_percentage;
	const pgChargesPercentage = isInternationalEvent
		? eventDetails.non_inr_pg_percentage
		: isInternationalTicket
			? eventDetails.kh_percentage + eventDetails.non_inr_pg_percentage
			: eventDetails.kh_percentage + paymentMethodFee; // 4
	const isPgChargeInclusive = eventDetails.is_pg_charge_inclusive;
	const isTaxInclusive = eventDetails.is_tax_inclusive;
	const isTaxable = eventDetails.is_taxable;
	const taxName = eventDetails.tax_name;

	const taxPercentageOnPg = eventDetails.tax_percentage_on_pg;
	const isTaxOnPgInclusive = eventDetails.is_tax_on_pg_inclusive;
	const basePgPercentage =
		eventDetails.non_inr_pg_percentage / (1 + eventDetails.tax_percentage_on_pg / 100);

	const [errors, seterrors] = useState([]);

	let pvt_discount = selectedTickets.map(
		ticket => ticket.discounted_price && ticket.discounted_price * ticket.totalSelected
	);
	pvt_discount = pvt_discount.reduce((prev, curr) => prev + curr, 0) || 0;
	let originalPrice = 0;

	const currency = selectedTickets?.find(obj => obj?.currency_name !== eventDetails?.currency_name)
		? selectedTickets?.find(obj => obj?.currency_name !== eventDetails?.currency_name)?.currency_name
		: eventDetails?.currency_name;

	//for group ticket discount
	const group_discount = groupDiscountDetails.maxDiscount;

	selectedTickets.map(
		ticket => (originalPrice = originalPrice + ticket.ticket_price * ticket.totalSelected)
	); // Calculating all the tickets price

	const ticket = new Ticket(
		originalPrice,
		isTaxable,
		!isTaxInclusive,
		taxPercentage,
		!isPgChargeInclusive,
		pgChargesPercentage,
		pvt_discount,
		group_discount,
		isTaxOnPgInclusive,
		taxPercentageOnPg,
		basePgPercentage
	);
	const ticketPriceDetails = ticket.calculate();

	//Waitlist useEffect - Check if waitlist ticket
	useEffect(() => {
		if (selectedTickets.length === 1 && curComp == 2) {
			let isWaitlist = false;
			selectedTickets.forEach(ticket => {
				if (
					(ticket.waitlist_enabled && ticket.sold_out) ||
					(ticket.remaining_count <= 0 && ticket.waitlist_enabled)
				) {
					ticket.waitlist_done ? (isWaitlist = false) : (isWaitlist = true);
				}
			});
			if (isWaitlist) setIsWaitlist(true);
		}
	}, [curComp]);

	useEffect(() => {
		const utm_campaign = typeof window !== 'undefined' && localStorage.getItem("utm_campaign")
			? localStorage.getItem("utm_campaign")
			: query.utm_campaign;
		const utm_medium = typeof window !== 'undefined' && localStorage.getItem("utm_medium")
			? localStorage.getItem("utm_medium")
			: query.utm_medium;
		const utm_source = typeof window !== 'undefined' && localStorage.getItem("utm_source")
			? localStorage.getItem("utm_source")
			: query.utm_source;

		const utm = {
			...(utm_source && { utm_source: utm_source }),
			...(utm_medium && { utm_medium: utm_medium }),
			...(utm_campaign && { utm_campaign: utm_campaign })
		};

		widgetContext.setUtm(utm); // set utm params
	}, [query]);

	useEffect(() => {
		widgetContext.setOrderAmount(parseFloat(ticketPriceDetails.rounded)); // also set order amount
	}, [selectedTickets, ticketPriceDetails]);

	const storeAndredirect = (data, eventDet, value) => {
		sessionStorage.setItem("data", data);
		sessionStorage.setItem("eventDetails", eventDet);

		//remove utm parameters
		localStorage.removeItem("utm_campaign");
		localStorage.removeItem("utm_medium");
		localStorage.removeItem("utm_source");

		const registrationType = isApproval
			? "Approval"
			: isWaitlist
				? "Waitlist"
				: value === "freeRegistration"
					? "freeRegistration"
					: "";

		//Redirect
		if (widgetContext.isWidget)
			Router.push({
				pathname: `/widget/ticket-confirmation`,
				query: query
			});
		else if (eventId === "b76abab5-6eed-44ff-956a-f2f39ce6d748") {
			Router.push({
				pathname: `https://chat.whatsapp.com/IHoRiFsaMUe4OU1pgu5yJB`
			});
		} else if (eventDetails.redirection_url !== null) {
			if (eventDetails.redirection_url_timeout == 0) {
				window.location.replace(eventDetails.redirection_url);
			} else {
				query.redirection_url = eventDetails.redirection_url;
				query.redirection_url_timeout = eventDetails.redirection_url_timeout;
				query.registrationType = registrationType;
				Router.push({
					pathname: `/checkout/CustomRedirects`,
					query: query
				});
			}
		} else
			Router.push({
				pathname: `/checkout/ticket-confirmation`,
				query: `eventUrl=${eventDetails.event_url}`
			});
	};

	const freeRegistration = async () => {
		const payload = {
			event_id: eventDetails.event_id,
			...(groupDiscountDetails.maxDiscountCode && {
				group_discount_code: groupDiscountDetails.maxDiscountCode
			}),
			...(widgetContext.couponCode && {
				coupon_code: widgetContext.couponCode
			}),
			...(widgetContext.otp && { otp: widgetContext.otp }),
			utm: widgetContext.utm,
			registration_details: attendeesDetails,
			...addTeamDetailsToCapture(widgetContext.teamRegType)
		};
		setApiLoading(true);
		try {
			const res = await captureApi(payload);
			const data = JSON.stringify(res.data);
			const eventDet = JSON.stringify(eventDetails);
			removeTeamDetailsFromSessionStorage(widgetContext.teamRegType);
			storeAndredirect(data, eventDet, "freeRegistration");
		} catch (err) {
			const errMessage = err.response.data;
			if (errMessage.error.error_code)
				widgetContext.setModalErrType(errMessage.error.error_code);
			else widgetContext.setModalErrType(paymentErrorHelper(errMessage.error));
			widgetContext.setOpenErrModal(true);
			setApiLoading(false);
		}
	};

	const waitlistRegistration = async () => {
		const ticketId = Object.keys(attendeesDetails)[0];
		const payload = {
			registration_tz: eventDetails.time_zone,
			ticket_id: parseInt(ticketId),
			waitlist_details: {
				booking_id: widgetContext.leadsResponse.booking_ids[0],
				...GSTDetails,
				...attendeesDetails[ticketId][0],
				...(utm && { utm: utm }),
				...(widgetContext.couponCode && {
					coupon_code: widgetContext.couponCode
				})
			},
			...(widgetContext.otp && { otp: widgetContext.otp })
		};
		setApiLoading(true);
		try {
			const res = await createWaitlist(payload, eventDetails.event_id, !isApproval);
			const data = JSON.stringify({
				waitlist: true,
				message: res.data,
				isApproval: isApproval
			});
			const eventDet = JSON.stringify(eventDetails);
			storeAndredirect(data, eventDet);
		} catch (err) {
			console.log(err);
			const errMessage = err?.response?.data || "Something went wrong";
			widgetContext.setModalErrType(paymentErrorHelper(errMessage.error));
			widgetContext.setOpenErrModal(true);
			setApiLoading(false);
		}
	};

	function toggleTicketSummary() {
		setShowTicketSummary(!showTicketSummary);
	}

	const getFinalPrice = () => {
		if (paymentMethod || isInternationalEvent || isPgChargeInclusive)
			return ticketPriceDetails.rounded;
		else if (isTaxable && !isTaxInclusive && !isPgChargeInclusive)
			return `${parseFloat(formatCurrencyAmount(ticketPriceDetails?.subTotal, currency)) +
				parseFloat(formatCurrencyAmount(ticketPriceDetails?.taxAmount, currency))
				}*`;
		else if (isTaxInclusive && !isPgChargeInclusive)
			return `${parseFloat(formatCurrencyAmount(ticketPriceDetails?.subTotal, currency))}*`;
		else if (isTaxInclusive && isPgChargeInclusive) return ticketPriceDetails.rounded;
		else if (!isTaxInclusive && !isPgChargeInclusive)
			return `${parseFloat(formatCurrencyAmount(ticketPriceDetails?.subTotal, currency)) +
				parseFloat(formatCurrencyAmount(ticketPriceDetails?.taxAmount, currency))
				}*`;
		else return ticketPriceDetails.rounded;
	};

	return (
		<div className="cart-box-container mx-auto">
			<div className="cart-box-sticky-container">
				<div className="cart-box p-3">
					<ViewSummary
						showModal={showTicketSummary}
						onCloseModal={toggleTicketSummary}
						query={query}
					>
						<TicketSummary
							reviewDetails={reviewDetails}
							selectedTickets={selectedTickets}
							groupDiscounts={groupDiscounts}
							attendeesDetails={attendeesDetails}
							couponCode={widgetContext.couponCode}
							paymentMethod={paymentMethod}
							eventDetails={eventDetails}
							query={query}
							isMobile={true}
							curComp={curComp}
							isInternationalEvent={isInternationalEvent}
						/>
					</ViewSummary>
					{/* Price Box */}
					<div
						className="price-box"
						style={{ borderRadius: `${query?.borderRadius || 10}px` }}
					>
						{_.isEmpty(selectedTickets) ? (
							<div className="d-flex flex-column align-items-center mb-2 justify-content-center py-5 px-2 d-md-flex d-none">
								{!widgetContext.isWidget ? (
									<img className="cart-img" src="/img/checkout/cart-img.svg" />
								) : (
									<i className="fas fa-shopping-cart widget-sopping-cart"></i>
								)}
								<p className="cart-text mt-4 mb-0 text-center">
									You haven't selected any ticket. Select a ticket to see the
									ticket summary.
								</p>
							</div>
						) : (
							<div className="d-md-flex d-none">
								<TicketSummary
									reviewDetails={reviewDetails}
									selectedTickets={selectedTickets}
									attendeesDetails={attendeesDetails}
									couponCode={widgetContext.couponCode}
									eventDetails={eventDetails}
									groupDiscounts={groupDiscounts}
									query={query}
									isMobile={false}
									curComp={curComp}
									paymentMethod={paymentMethod}
									isInternationalEvent={isInternationalEvent}
								/>
							</div>
						)}
					</div>
					{!_.isEmpty(groupDiscounts) && isMobile && (
						<div className="mb-4">
							<OfferBox
								query={query}
								groupDiscounts={groupDiscounts}
								ticketDetails={ticketDetails}
								isWidget={widgetContext.isWidget}
							/>
						</div>
					)}
					{/* Coupon Box */}
					{eventDetails.has_coupons || eventDetails.has_access_codes ? (
						<CouponBox
							eventDetails={eventDetails}
							query={query}
							ticketDetails={ticketDetails}
							getCouponDetails={getCouponDetails}
							removeCoupon={removeCoupon}
							// disabled={groupDiscountDetails.maxDiscountCode !== ""}
							// disabledContent={groupDiscountDetails.maxDiscountCode !== "" ? "Access / discount codes cannot be combined with group discounts. Please remove the group discounted tickets to use a access / discount code." : ""}
							couponErr={couponErr}
							setCouponErr={setCouponErr}
							waitlistDetails={waitlistDetails}
							isWidget={/*widgetContext.isWidget*/ false}
							setFormRules={setFormRules}
							isEventPageTeamComp={isEventPageTeamComp}
							selectedTickets={selectedTickets}
						/>
					) : (
						""
					)}

					{/* Proceed / Clear Button */}
					<CartButtons
						onProceed={onProceed}
						eventDetails={eventDetails}
						setIsCheckoutSubmitted={setIsCheckoutSubmitted}
						curComp={curComp}
						selectedTickets={selectedTickets}
						query={query}
						freeRegistration={freeRegistration}
						waitlistRegistration={waitlistRegistration}
						apiLoading={apiLoading}
						utm={widgetContext.utm}
						isWidget={widgetContext.isWidget}
						couponCode={widgetContext.couponCode}
						btnDisabled={errors.length}
						orderAmount={parseFloat(ticketPriceDetails.rounded)}
						orderAmountPreview={getFinalPrice()}
						isWaitlist={isWaitlist}
						setApiLoading={setApiLoading}
						attendeesDetails={attendeesDetails}
						reviewDetails={reviewDetails}
						toggleTicketSummary={toggleTicketSummary}
						discount={pvt_discount} //accessCode/coupons discount
						emailApiErrors={emailApiErrors}
						waitlistDetails={waitlistDetails}
						textInputErrors={textInputErrors}
						isValidating={isValidating}
					/>
					{/* Powered by mobile logo */}
					{/* {!widgetContext.isWidget && <div className="mobile-sticky">
          <hr className="d-block d-md-none m-0 mb-3 powered-by-line" />
          <a
            href={baseUrl}
            target="_blank"
            className="d-block d-md-none powered-by-text text-center"
          >
            <span className="powered-by-text">Powered by</span>
            <img
              src="/logos/konfhub-logo-purple.svg"
              style={{ width: "100px" }}
            />
          </a>
        </div>} */}
				</div>
				{!_.isEmpty(groupDiscounts) && !isMobile && (
					<OfferBox
						query={query}
						groupDiscounts={groupDiscounts}
						ticketDetails={ticketDetails}
						isWidget={widgetContext.isWidget}
					/>
				)}
			</div>
			{apiLoading && (
				<div className="checkout-overlay">
					<p className="checkout-overlay-text m-0">Please Wait</p>
					<div className="spinner-border ms-2"></div>
				</div>
			)}
			<style jsx>{`
				.cart-box-container {
					min-width: 350px;
					max-width: 450px;
					width: 40%;
				}
				.cart-box-sticky-container {
					position: sticky;
					top: 10px;
				}
				.cart-box {
					background: ${query.secondaryBg
					? `#${query.secondaryBg}`
					: isWidget
						? "#F7F7F7"
						: "#EFE9ED"};
					border: 2px solid ${query.borderCl ? `#${query.borderCl}` : "#EFE9ED"};
					border-radius: ${query?.borderRadius || 10}px;
				}
				.widget-sopping-cart {
					font-size: 60px;
					color: ${query.primaryCl ? `#${query.primaryCl}` : "#b79fb1"};
				}
				.price-box {
					background: ${query.primaryBg ? `#${query.primaryBg}` : "#FFF"};
				}
				.cart-text {
					font-size: 14px;
					color: ${query.primaryCl ? `#${query.primaryCl}` : "#572148"};
				}
				.proceed-btn {
					color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
					background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
				}

				.proceed-btn:hover {
					color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
				}

				.proceed-outline-btn {
					background: transparent;
					border-radius: 5px;
					font-size: 18px;
					font-weight: 500;
					padding: 10px 30px;
					transition: 0.2s all;
					color: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
					border: 1px solid ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
				}

				.proceed-outline-btn:hover {
					color: ${query.btnCl ? `#${query.btnCl}` : "#ffffff"};
					background: ${query.btnBg ? `#${query.btnBg}` : "#fb5850"};
				}

				.powered-by-text {
					color: #999999;
					font-size: 16px;
					text-decoration: none !important;
				}
				.powered-by-line {
					opacity: 1;
				}
				.checkout-overlay {
					display: flex;
					justify-content: center;
					align-items: center;
					color: white;
					position: fixed; /* Sit on top of the page content */
					width: 100%; /* Full width (cover the whole page) */
					height: 100%; /* Full height (cover the whole page) */
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background-color: rgb(0 0 0 / 83%); /* Black background with opacity */
					z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
				}

				@media (max-width: 768px) {
					.cart-box-container {
						min-width: 30px;
						max-width: 768px;
						width: 100%;
					}
					.cart-box {
						background: white;
						border: none;
						padding-top: 0px !important;
						position: relative;
						padding: 0px 1em !important;
					}
					.price-box {
						box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
					}
				}
			`}</style>
		</div>
	);
};

export default CartBox;
